import { render, staticRenderFns } from "./deleteCityArea.vue?vue&type=template&id=593324df&scoped=true"
import script from "./deleteCityArea.vue?vue&type=script&lang=js"
export * from "./deleteCityArea.vue?vue&type=script&lang=js"
import style0 from "./deleteCityArea.vue?vue&type=style&index=0&id=593324df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593324df",
  null
  
)

export default component.exports